import React from 'react';
import propTypes from 'prop-types';
import classNames from 'classnames';
import Image from '../Image';
import Button from '../Button';
import Badge from '../Badge';
import { useMediaQuery } from 'react-responsive';

function DiscoverBanner(props) {
  const {
    image, className, title, description, primaryBtn, secondaryBtn, badgeText, variant, loading
  } = props;
  const isMobile = useMediaQuery({ maxWidth: 768 });
  return (
    <div className={classNames('discover-banner__wrapper', `${loading ? 'primary' : variant}-banner-background`, className)}>
      {loading ? (
        <div className="discover-banner__right">
          <div className="discover-banner__right-top">
            <span className="discover-banner__title"></span>
          </div>
        </div>
      ) : (
        <>
          <div className="discover-banner__right">
            <div className="discover-banner__right-top">
              <span className="discover-banner__title">{title}{badgeText && <Badge size="md" iconBefore="flashlight" iconType="fill">{badgeText}</Badge>}</span>
              <span className="discover-banner__description">{description}</span>
            </div>
            <div className="discover-banner__right-bottom">
              {primaryBtn?.text && (
                <Button
                  variant={variant}
                  size="sm"
                  className={classNames('discover-banner__primary-btn', 'mr-3')}
                  onClick={() => primaryBtn.url && window.open(primaryBtn.url, '_blank')}
                >
                  {primaryBtn.text}
                </Button>
              )}
              {secondaryBtn?.text && (
                <Button
                  variant="outline-gray"
                  size="sm"
                  className="discover-banner__secondary-btn"
                  onClick={() => secondaryBtn.url && window.open(secondaryBtn.url, '_blank')}
                >
                  {secondaryBtn.text}
                </Button>
              )}
            </div>
          </div>
          {!isMobile && image && <div className="discover-banner__left">
            <Image src={image} className="discover-banner__left-image" />
          </div>}
        </>
      )}
    </div>
  );
}

DiscoverBanner.propTypes = {
  image: propTypes.string.isRequired,
  title: propTypes.string.isRequired,
  description: propTypes.string.isRequired,
  primaryBtn: propTypes.shape({
    text: propTypes.string.isRequired,
    url: propTypes.string.isRequired
  }),
  secondaryBtn: propTypes.shape({
    text: propTypes.string.isRequired,
    url: propTypes.string.isRequired
  }),
  badgeText: propTypes.string,
  className: propTypes.string,
  variant: propTypes.string.isRequired,
  loading: propTypes.bool
};

DiscoverBanner.defaultProps = {
  className: '',
  loading: false,
  badgeText: null,
  primaryBtn: null,
  secondaryBtn: null
};

export default DiscoverBanner;
